import { AppPages } from '../AppRouter'

export interface IRoute<T extends object = {}> {
    name: string
    params?: T
}

export class AppRoutes {
    private constructor() {}

    static getMainPage() {
        return getRoute(AppPages.mainPage);
    }
    static getCabinet() {
        return getRoute(AppPages.personalAccount);
    }
    static getCreateDocument() {
        return getRoute(AppPages.createDocument);
    }
    static openDocument(id: number) {
        return getRoute(AppPages.documentInfo, { id });
    }
    static openIncomingDoc(id: number) {
        return getRoute(AppPages.incomingDoc, { id });
    }
    static openOutgoingDoc(id: number) {
        return getRoute(AppPages.outgoingDoc, { id });
    }
    static getDraftList() {
        return getRoute(AppPages.draftList, {});
    }
    static getDraftDocument(id: number) {
        return getRoute(AppPages.draftDocument, {id});
    }
    static getOutgoing() {
        return getRoute(AppPages.outgoing, {});
    }
    static getIncoming() {
        return getRoute(AppPages.incoming, {});
    }
    static getMainTariffs() {
        return getRoute(AppPages.mainTariffs, {});
    }
    static getCabinetTariffs() {
        return getRoute(AppPages.cabinetTariffs, {});
    }
}

function getRoute<T extends object = {}>(name: string, params?: T): IRoute<T> {
    return {
        name,
        params
    }
}